export enum PowerOfAttorneyStatusType {
    NICHT_GEPRUEFT = 0,
    PROVISORISCH = 1,
    AKTIV = 2,
    AUFGEHOBEN = 3,
    VERSTORBEN = 4,
    UNGUELTIG = 5,
    GELOESCHT = 9,
}
